export default {
  BROWSER_EXTENSION: 'browser-extension',
  APP: 'app',
  EXPORTER: 'exporter',
  SERP_SIMULATOR: 'serp-simulator'
};